import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/AdminLayout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: 'dashboard', icon: 'el-icon-s-data' }
      },
      {
        path: '/cars',
        name: 'Cars',
        component: () => import('@/views/cars/CarList.vue'),
        meta: { title: 'cars', icon: 'el-icon-truck' }
      },
      {
        path: '/cars/create',
        name: 'CarCreate',
        component: () => import('@/views/cars/CarForm.vue'),
        meta: { title: 'createCar', hidden: true }
      },
      {
        path: '/cars/:id/edit',
        name: 'CarEdit',
        component: () => import('@/views/cars/CarForm.vue'),
        meta: { title: 'editCar', hidden: true }
      },
      {
        path: '/submissions',
        name: 'Submissions',
        component: () => import('@/views/Submissions.vue'),
        meta: { title: 'submissions', icon: 'el-icon-document' }
      },
      {
        path: '/users',
        name: 'Users',
        component: () => import('@/views/Users.vue'),
        meta: { title: 'users', icon: 'el-icon-user' }
      },
      {
        path: '/settings',
        name: 'Settings',
        component: () => import('@/views/Settings.vue'),
        meta: { title: 'settings', icon: 'el-icon-setting' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// Navigation guard for authentication
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('admin_token')

  if (to.path !== '/login' && !token) {
    next('/login')
  } else if (to.path === '/login' && token) {
    next('/')
  } else {
    next()
  }
})

export default router
